import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Formik, FormikHelpers, FormikProps, FormikState } from 'formik';
import { Col, PageHeader } from 'react-bootstrap';
import { InjectedProps } from '../../types';
import { AppointmentTypes } from '../../types/AppointmentType';
import ControlButtonGroup from '../misc/ControlButtonGroup';
import AppointmentTypeForm, { IAppointmentType } from './AppointmentTypeForm';
import { emptyAppointmentType } from '../../store/initial';
import DefaultRoutes from '../../routes/DefaultRoutes';

interface AppointmentTypeEditState {
    editing: boolean;
}

@inject('store')
@observer
export class AppointmentTypeEdit extends React.Component<{}, AppointmentTypeEditState> {
    public get injected() {
        return this.props as InjectedProps;
    }

    public state = {
        editing: false
    };

    public initialValues = (appointmentTypes: AppointmentTypes) => {
        const { isLoading } = this.injected.store;
        return isLoading ? emptyAppointmentType : appointmentTypes;
    };

    public get id() {
        return this.injected.store.router.params.id ? parseInt(this.injected.store.router.params.id, 10) : 0;
    }

    public getAppointmentTypes() {
        return this.injected.store.appointmentTypes.getItem(this.id);
    }

    public fetchData() {
        const { fetchAppointmentType } = this.injected.store;
        return fetchAppointmentType(this.id);
    }

    public componentDidMount() {
        return this.fetchData();
    }

    public render() {
        const appointmentTypes = this.getAppointmentTypes();
        const initialValues = this.initialValues(appointmentTypes);

        if (!initialValues) {
            return null;
        }

        return (
            <>
                <PageHeader>Schedule Genie Appointment Types</PageHeader>
                <Col className="fixed-controls">
                    <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        onSubmit={this.handleSubmit}
                    >{this.renderForm()}</Formik>
                </Col>
            </>
        );
    }

    public renderForm = () => {
        return AppointmentTypeForm({
            editing: this.state.editing,
            controls: (bag: FormikProps<IAppointmentType>) => (
                <ControlButtonGroup
                    editing={this.state.editing}
                    canEdit
                    canDelete={this.state.editing}
                    handleEdit={this.toggleEdit}
                    handleCancel={this.handleCancel(bag)}
                    handleBack={this.handleBack}
                    handleDelete={this.handleDelete}
                />
            )
        });
    };

    public toggleEdit = () => {
        this.setState({ editing: !this.state.editing });
    };

    public handleCancel = (bag: FormikProps<IAppointmentType>) => () => {
        this.setState({ editing: false });
        bag.resetForm(bag.initialValues as Partial<FormikState<IAppointmentType>>);
    };

    public handleBack = () => {
        const { router } = this.injected.store;
        router.goTo(DefaultRoutes.AppointmentTypeList, {}, this.injected.store);
    };

    public handleSubmit = (
        values: AppointmentTypes,
        actions: FormikHelpers<AppointmentTypes>
    ) => {
        actions.setSubmitting(true);
        const { appointmentTypes } = this.injected.store;
        return appointmentTypes.update(values)
            .then(() => {
                actions.setSubmitting(false);
                this.setState({ editing: false });
            })
            .catch(error => {
                actions.setErrors(error.response.data);
                actions.setSubmitting(false);
            });
    };

    protected handleDelete = () => {
        if (window.confirm('Are you sure you wish to delete this item?')) {
            this.injected.store.deleteAppointmentType(this.id);
            this.handleBack();
        }
        return;
    };
}

export default AppointmentTypeEdit;
